import React from "react";
import styled from "styled-components";
import { ToastContainer as ReactToastifyContainer } from "react-toastify";

const StyledToastContainer = styled(ReactToastifyContainer)`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast-container {
    padding: 0;
  }
  .Toastify__toast {
    padding: 0;
    box-shadow: none;
    min-height: unset;
    overflow: unset;
  }

  .Toastify__toast-body {
    padding: 0;
  }
`;

export const ToastContainer = () => {
  return (
    <StyledToastContainer
      hideProgressBar={true}
      position="top-right"
      autoClose={3000}
    />
  );
};
